<template>
  <div>
    <a @click="open('start')" class="baojiaAddress">{{ startText }}</a>
    <span class="returntype" @click="changeType">{{ ttype[type]
      }}</span> <a class="baojiaAddress" @click="open('end')">{{ endText }}</a>
    <select-city v-show="false" @addAdcode="getValue" :hideInput="true" ref="city">
    </select-city>
  </div>
</template>
<script>
export default {
  props: ["startAdd", "endAdd", "transportType"],

  data() {
    return {
      start: "",
      startText: "",
      end: "",
      endText: "",
      now: 'start',
      type: 0,
      ttype: {
        1: '=>',
        0: '<=>'
      }
    };
  },
  methods: {
    chushihua() {
      this.start = this.startAdd;
      this.startText = this.startAdd.split('-')[0];
      this.end = this.endAdd;
      this.endText = this.endAdd.split('-')[0];
      this.type = this.transportType;
    },
    open(v) {
      this.now = v;
      this.$refs.city.open();
    },
    getValue(v) {

      if (this.now == 'start') {
        this.startText = v.split('-')[0];
        this.$emit("start", v);
      } else {
        this.endText = v.split('-')[0];
        this.$emit("end", v);
      }
    },

    changeType() {
      if (this.type === 0) {
        this.type = 1
      } else {
        this.type = 0
      }
      this.$emit("transportType", this.type);
    }
  },
  mounted() {
    this.chushihua();
  },
  watch: {
    startAdd(v) {
      this.start = v;
      this.startText = v.split('-')[0];
    },
    endAdd(v) {
      this.end = v;
      this.endText = v.split('-')[0];
    },
    transportType(v) {
      this.type = v;
    },
  },
};
</script>
<style lang="">
  .baojiaAddress{
    display: inline-block;
    min-width: 20px;
    min-height: 20px;
    
  }
  .returntype{
    cursor:pointer;
    margin-left:6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/startAddendAdd.vue